export default "__VITE_ASSET__CWWxj$Cj__"